/* HS Activa Neubau: Produktseite (Varianten, Galerie, Sticky, Lieferhinweis, Empfehlungen). */
(function () {
  /* Varianten */
  class VariantSelects extends HTMLElement {
    connectedCallback() {
      try { this.variants = JSON.parse(this.querySelector('[data-variants]').textContent); } catch (e) { this.variants = []; }
      this.sectionId = this.dataset.section;
      this.addEventListener('change', () => this.onChange());
      this.decorate();
    }
    decorate() {
      this.querySelectorAll('.variant-value:not([data-fmt])').forEach((el) => {
        const t = el.textContent.trim();
        if (t.includes(' - ')) { const [a, ...r] = t.split(' - '); el.innerHTML = '<b></b><small></small>'; el.firstChild.textContent = a; el.lastChild.textContent = r.join(' - '); }
        el.setAttribute('data-fmt', '1');
      });
    }
    selected() {
      const out = [];
      this.querySelectorAll('fieldset').forEach((fs) => { const c = fs.querySelector('input:checked'); out.push(c ? c.value : null); });
      return out;
    }
    onChange() {
      const sel = this.selected();
      const variant = this.variants.find((v) => v.options.every((o, i) => o === sel[i]));
      this.querySelectorAll('fieldset').forEach((fs, i) => { const l = fs.querySelector('[data-selected-swatch-value]'); if (l) l.textContent = sel[i] || ''; });
      const section = document.getElementById('shopify-section-' + this.sectionId) || this.closest('.shopify-section');
      if (!variant) { this.setUnavailable(section); return; }
      this.updateForms(variant);
      this.updatePrice(section, variant);
      this.updateMedia(variant);
      this.updateUrl(variant);
      publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId: this.sectionId, variant } });
    }
    forms() {
      const out = [];
      document.querySelectorAll('form[id^="product-form-' + this.sectionId + '"], form[id*="sticky"][data-type="add-to-cart-form"]').forEach((f) => { if (!f.closest('cart-drawer, .recommended-product, .card')) out.push(f); });
      return out;
    }
    updateForms(variant) {
      this.forms().forEach((f) => {
        const id = f.querySelector('input[name="id"]'); if (id) { id.value = variant.id; id.disabled = !variant.available; }
        const btn = f.querySelector('[type="submit"]'); if (btn) {
          btn.disabled = !variant.available; btn.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
          const span = btn.querySelector('span') || btn; span.textContent = variant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
        }
      });
    }
    setUnavailable(section) {
      this.forms().forEach((f) => { const btn = f.querySelector('[type="submit"]'); if (btn) { btn.disabled = true; (btn.querySelector('span') || btn).textContent = window.variantStrings.unavailable; } });
    }
    updatePrice(section, variant) {
      const targets = [document.getElementById('price-' + this.sectionId), document.getElementById('sticky-price-' + this.sectionId.replace('__main', '__sticky_add_to_cart'))];
      document.querySelectorAll('sticky-add-to-cart .sticky__price').forEach((t) => targets.push(t));
      targets.forEach((t) => {
        if (!t) return;
        const price = t.querySelector('.price'); if (!price) return;
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        price.classList.toggle('price--on-sale', !!onSale);
        price.classList.toggle('price--sold-out', !variant.available);
        const reg = price.querySelector('.price__regular .price-item--regular'); if (reg) reg.textContent = HS.money(variant.price);
        const cmp = price.querySelector('.price__sale .price-item--regular'); if (cmp) cmp.textContent = HS.money(variant.compare_at_price || variant.price);
        const sale = price.querySelector('.price-item--sale'); if (sale) sale.textContent = HS.money(variant.price);
        const badge = price.querySelector('.price__badge'); if (badge) badge.textContent = onSale ? 'Sie sparen ' + HS.money(variant.compare_at_price - variant.price) : '';
      });
    }
    updateMedia(variant) {
      if (!variant.featured_media) return;
      const g = document.querySelector('product-gallery[data-section="' + this.sectionId + '"]');
      if (g && g.goToMedia) g.goToMedia(variant.featured_media.id);
    }
    updateUrl(variant) {
      if (!window.history.replaceState) return;
      const u = new URL(window.location.href); u.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', u.toString());
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /* Galerie */
  /* Scroll-Snap-Spur: Index aus der Scroll-Position, Sprung per scrollTo (Wischen macht der Browser) */
  const idxOf = (track) => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
  const smooth = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.gallery__track');
      this.slides = [...this.querySelectorAll('.gallery__slide')];
      this.dots = [...this.querySelectorAll('.gallery__dots span')];
      this.thumbs = [...this.querySelectorAll('.gallery__thumb')];
      this.prev = this.querySelector('.gallery__prev'); this.next = this.querySelector('.gallery__next');
      this.count = this.querySelector('[data-count]');
      this.dialog = this.querySelector('dialog.lightbox');
      this.index = 0;
      if (this.prev) this.prev.addEventListener('click', () => this.go(this.index - 1));
      if (this.next) this.next.addEventListener('click', () => this.go(this.index + 1));
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(+t.dataset.index)));
      /* Sobald jemand die Galerie anfasst, alle Bilder laden (vorher lazy): Wischen ohne Wartezeit, kein weißes Bild nach der Großansicht */
      ['touchstart', 'pointerdown', 'keydown'].forEach((ev) => this.track.addEventListener(ev, () => this.warm(), { once: true, passive: true }));
      let t; this.track.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => this.sync(), 60); }, { passive: true });
      this.track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); } });
      this.addEventListener('click', (e) => { const z = e.target.closest('.gallery__zoom'); if (z) this.openLightbox(+z.closest('.gallery__slide').dataset.index); });
      if (this.dialog) this.setupLightbox();
      const th = this.querySelector('.gallery__thumbs');
      if (th) { const f = () => th.classList.toggle('is-overflow', th.scrollTop + th.clientHeight < th.scrollHeight - 4); th.addEventListener('scroll', f, { passive: true }); if ('ResizeObserver' in window) new ResizeObserver(f).observe(th); f(); }
    }
    warm() {
      if (this._warm) return; this._warm = true;
      this.querySelectorAll('.gallery__img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
    }
    go(i) {
      if (!this.slides.length) return;
      this.warm();
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      this.track.scrollTo({ left: this.slides[i].offsetLeft - this.track.offsetLeft, behavior: smooth });
      this.index = i; this.paint();
    }
    goToMedia(id) { const i = this.slides.findIndex((s) => s.dataset.mediaId == id); if (i >= 0) this.go(i); }
    sync() {
      const i = Math.max(0, Math.min(this.slides.length - 1, idxOf(this.track)));
      if (i !== this.index) { this.index = i; this.paint(); }
    }
    paint() {
      const n = this.slides.length;
      this.dots.forEach((d, i) => d.classList.toggle('is-on', i === this.index));
      this.thumbs.forEach((t, i) => { t.classList.toggle('is-on', i === this.index); t.setAttribute('aria-selected', i === this.index ? 'true' : 'false'); });
      const on = this.thumbs[this.index];
      if (on && on.parentElement.scrollHeight > on.parentElement.clientHeight + 2) on.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (this.prev) this.prev.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === n - 1;
      if (this.count) this.count.textContent = this.index + 1;
      publish('hs:gallery', { index: this.index, total: n });
    }
    /* Großansicht: eigene Wisch-Spur mit allen Bildern, Pfeile, Pfeiltasten */
    setupLightbox() {
      const d = this.dialog;
      this.lTrack = d.querySelector('.lightbox__track');
      this.lCount = d.querySelector('[data-lcount]');
      this.lPrev = d.querySelector('.lightbox__prev'); this.lNext = d.querySelector('.lightbox__next');
      const zooms = [...this.querySelectorAll('.gallery__zoom')];
      this.lMap = [];
      /* Bildgröße für die Großansicht am Gerät ausrichten (Handy braucht keine 1800 px): längste Bildschirmkante mal Pixeldichte, auf 100 gerundet */
      const best = Math.min(1800, Math.ceil(Math.max(innerWidth, innerHeight) * Math.min(devicePixelRatio || 1, 2) / 100) * 100);
      zooms.forEach((z) => {
        const s = document.createElement('div'); s.className = 'lightbox__slide';
        const img = document.createElement('img'); img.alt = ''; img.decoding = 'async'; img.dataset.src = (z.dataset.zoom || '').replace(/([?&])width=\d+/, `$1width=${best}`);
        if (z.dataset.w) { img.width = z.dataset.w; img.height = z.dataset.h; }
        s.appendChild(img); this.lTrack.appendChild(s);
        this.lMap.push(+z.closest('.gallery__slide').dataset.index);
      });
      if (this.lPrev) this.lPrev.addEventListener('click', () => this.lGo(this.lIndex - 1));
      if (this.lNext) this.lNext.addEventListener('click', () => this.lGo(this.lIndex + 1));
      let t; this.lTrack.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => { this.lIndex = idxOf(this.lTrack); this.lPaint(); }, 60); }, { passive: true });
      d.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); this.lGo(this.lIndex + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); this.lGo(this.lIndex - 1); } });
      d.addEventListener('click', (e) => { if (e.target === d || e.target.classList.contains('lightbox__slide')) d.close(); });
      /* Nicht nur auf "close" verlassen (kam in manchen Chromium-Builds nicht an, Seite blieb gesperrt): auch toggle + open-Attribut, siehe HS.watchDialog. */
      const onClose = () => { HS.lock(false); const gi = this.lMap[this.lIndex]; if (gi !== undefined && gi !== this.index) { this.index = gi; this.track.scrollTo({ left: this.slides[gi].offsetLeft - this.track.offsetLeft }); this.paint(); } };
      d.addEventListener('close', onClose);
      d.addEventListener('toggle', () => { if (!d.open) onClose(); });
      if (window.HS && HS.watchDialog) HS.watchDialog(d);
    }
    openLightbox(galleryIndex) {
      if (!this.dialog) return;
      const li = Math.max(0, this.lMap.indexOf(galleryIndex));
      this.warm();
      this.dialog.showModal(); HS.lock(true);
      this.lIndex = li; this.lLoad(li);
      this.lTrack.scrollLeft = li * this.lTrack.clientWidth; this.lPaint(); this.lTrack.focus({ preventScroll: true });
    }
    lLoad(i) { [i - 1, i, i + 1].forEach((k) => { const img = this.lTrack.children[k] && this.lTrack.children[k].querySelector('img'); if (img && !img.src) img.src = img.dataset.src; }); }
    lGo(i) { const n = this.lTrack.children.length; i = Math.max(0, Math.min(n - 1, i)); this.lIndex = i; this.lLoad(i); this.lTrack.scrollTo({ left: i * this.lTrack.clientWidth, behavior: smooth }); this.lPaint(); }
    lPaint() {
      const n = this.lTrack.children.length; this.lLoad(this.lIndex);
      if (this.lCount) this.lCount.textContent = this.lIndex + 1;
      if (this.lPrev) this.lPrev.disabled = this.lIndex === 0;
      if (this.lNext) this.lNext.disabled = this.lIndex === n - 1;
    }
  }
  customElements.define('product-gallery', ProductGallery);

  /* Sticky-Leiste: Element nur als Haken, die Logik steckt im Inline-Script hs-sticky-consent */
  class StickyAddToCart extends HTMLElement {}
  customElements.define('sticky-add-to-cart', StickyAddToCart);

  /* Lieferhinweis */
  class DeliveryInfo extends HTMLElement {
    connectedCallback() { this.render(); this._t = setInterval(() => this.render(), 30000); }
    disconnectedCallback() { clearInterval(this._t); }
    render() {
      const now = new Date();
      const [ch, cm] = (this.dataset.cutoff || '12:00').split(':').map(Number);
      const cutoff = new Date(now); cutoff.setHours(ch, cm, 0, 0);
      let start = new Date(now); start.setHours(0, 0, 0, 0);
      if (now > cutoff) { start.setDate(start.getDate() + 1); cutoff.setDate(cutoff.getDate() + 1); }
      const ms = cutoff - now; const h = Math.floor(ms / 3600000), m = Math.floor((ms % 3600000) / 60000);
      const rem = this.querySelector('[data-remaining]'); if (rem) rem.textContent = (h > 0 ? h + ' Std. ' : '') + m + ' Min.';
      const sat = this.dataset.sat === '1', sun = this.dataset.sun === '1';
      const add = (d, n) => { const x = new Date(d); let c = 0; while (c < n) { x.setDate(x.getDate() + 1); const wd = x.getDay(); if ((wd === 0 && !sun) || (wd === 6 && !sat)) continue; c++; } return x; };
      const WT = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
      const f = (d) => WT[d.getDay()] + ' ' + String(d.getDate()).padStart(2, '0') + '.' + String(d.getMonth() + 1).padStart(2, '0') + '.';
      const a = add(start, +this.dataset.min || 1), b = add(start, +this.dataset.max || 3);
      const dt = this.querySelector('[data-dates]'); if (dt) dt.textContent = f(a) + ' bis ' + f(b);
    }
  }
  customElements.define('delivery-info', DeliveryInfo);

  /* Empfehlungen nachladen (Related, Drawer) */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('.card, .recommended-product')) return;
      const load = () => {
        if (this._loaded) return; this._loaded = true;
        fetch(this.dataset.url).then((r) => r.text()).then((html) => {
          const d = new DOMParser().parseFromString(html, 'text/html');
          const el = d.querySelector('product-recommendations') || d.querySelector('#product-recommendations--' + this.dataset.block);
          if (el && el.innerHTML.trim()) this.innerHTML = el.innerHTML; else this.classList.add('is-empty');
        }).catch(() => {});
      };
      if (this.closest('cart-drawer')) return;
      if ('IntersectionObserver' in window) { const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { load(); io.disconnect(); } }, { rootMargin: '0px 0px 1400px 0px' }); io.observe(this); }
      else load();
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  /* Tracking-Anker: Galerie-Index für hs-tracking */
  subscribe('hs:gallery', () => {});
})();
